import React, { useEffect, useState, useRef } from "react";
import HttpService from "../../services/httpService";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import { connect } from "react-redux";
import { FormControl, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem/MenuItem';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from "@material-ui/core/Grid";
import Tooltip from '@material-ui/core/Tooltip';
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper,
    withStyles,
    TableContainer
} from "@material-ui/core";
import { Button } from "antd";
import { Modal } from "antd";
import { CSVLink } from "react-csv";
import moment from "moment";
import { ROLENAME } from '../../utils/index';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom'

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    },
    bordercolors: {
        border: '1px solid #eee5e5',
        background: "blue"
    },
    table: {
        minWidth: 700,
    },
    root: {
        width: '100%',
    },
    title: {
        fontSize: 14,
    },
    customTableContainer: {
        overflowX: "initial"
    },
    pos: {
        marginBottom: 12,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginpivotRight: theme.spacing(1),
        width: 200,
    },
    table: {
        width: "fit-content",
    },
    csv: {
        display: "flex",
        alignItems: "center",
        marginBottom: 20,
    },
    report: {
        marginBottom: 20,
        alignItems: "center",
        justifyContent: "center",
    },
    leadSearchButton: {
        backgroundColor: '#FDB913',
        color: '#151921',
        padding: '1',
        marginRight: '0.5em',
        borderRadius: '20px',
        width: '20%',
        "&:hover": { backgroundColor: "#14419c", color: 'white' }
    },
    leadClearButton: {
        backgroundColor: '#f7b7b7', // light red background
        color: '#151921',
        padding: '1',
        marginRight: '0.5em',
        borderRadius: '20px',
        width: '20%',
        // "&:hover": { 
        //     backgroundColor: "#f7b7b7", // same light red on hover
        //     color: '#151921' // same text color on hover
        // }
    },
    submitButton: {
        backgroundColor: '#F47E46 !important',  // Decorpot Orange
        color: 'white',            // White text
        '&:hover': {
          backgroundColor: '#E0663D !important', // Darker Orange on hover
        },
      },
}));

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#1C375D",
        color: '#FFF2EB',
        fontWeight: "500"
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);


const MIS1 = (props) => {
    const classes = useStyles();
    const { userDetails } = useSelector((state) => state.user);
    const [store, setStore] = useState([]);
    const [commonExpCenter, setExpCenter] = useState([])

    const [pivot, setPivot] = useState("mis1");
    const [storeDateFilter, setPivotDatefilters] = useState({ startDate: "", endDate: "" })
    const [selectedExperienceCenter, setSelectedExperienceCenter] = useState([])
    const months = ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', "Oct", "Nov", "Dec"];
    const [selectedValue, setSelectedValue] = useState("");
    const [showDetailedModal, setShowDetailedModal] = useState(false);
    const [title, setTitle] = useState("")
    const [csvData, setCsvData] = useState([]);
    const csvButtonRef = useRef(null);
    const [popMonthData, setPopMonthData] = useState([]);
    const [selectedRole, setSelectedRole] = useState('');
    const [usersData, setUsersData] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [status, setStaus] = useState('');
    const [selectLost, setSeletLost] = useState('')
    const [selectedDepartment, setSelectedDepartment] = useState("")
    const [searchInput, setSearchInput] = useState("")
    const [selectedSearchType, setSelectedSearchType] = useState("");
    const searchTypes = ['Customer Name', 'Email ID', 'Lead No', 'Project No', 'Contact No', 'Unique Lead No']

    useEffect(() => {
        expCenters();
        misReview();
    }, []);
    const headers = [
        { key: "serialNo", label: "Sl. No." },
        { key: "projectCode", label: "Project No." },
        { key: "leadNumber", label: "Lead No." },
        { key: "clientName", label: "Client Name" },
        { key: "totalValue", label: "Value (INR)" },
        { key: "expCtrName", label: "Exp. Ctr Name" },
        { key: "salesWonDate", label: "Sales Won Date" },
        { key: "internalDesignSignOffDate", label: "Internal Design Sign-Off Date" },
        { key: "designSignOffDate", label: "Customer Design Sign-Off Approval Date" },
        { key: "materialDeliveryDate", label: "Material Delivery Date" },
        { key: "actualCompletionDate", label: "Actual Completion Date" },
        { key: "HoldRevocationDate", label: "Revocation Date" },
        { key: "currentStage", label: "Current Stage" },
        { key: "department", label: "Department" }

    ];

    const csvDownloadHandler = async (data) => {
        setLoading(true);
        try {
            let csvArray = [];

            for (let i = 0; i < popMonthData.length; i++) {
                let obj = {
                    serialNo: i + 1,
                    projectCode: popMonthData[i]?.erpProjectNo || "N/A",
                    leadNumber: popMonthData[i]?.lead_no || "N/A",
                    createdAt: popMonthData[i]?.createdAt
                        ? moment(popMonthData[i]?.createdAt).format("DD-MM-YYYY")
                        : "-",
                    sourceOfLead: popMonthData[i]?.sourceOfLead?.name || "N/A",
                    clientName: popMonthData[i]?.customerId?.name,
                    totalValue: (
                        (["designerNotAssigned", "designKickOff", "design", "design-Hold", "salesLost", "designLost", "salesWonValue"].includes(title)) ?
                            (popMonthData[i]?.staticSalesWonBudget ? popMonthData[i]?.staticSalesWonBudget : "N/A") :
                            (popMonthData[i]?.staticDesignWonBudget ? popMonthData[i]?.staticDesignWonBudget : "N/A")
                    ),
                    expCtrName: popMonthData[i]?.experienceCenterId?.name,
                    salesWonDate: popMonthData[i]?.leadWonDate
                        ? moment(popMonthData[i]?.leadWonDate).format("DD-MM-YYYY")
                        : "-",
                    // salesUser: popMonthData[i]?.salesUser ? popMonthData[i]?.salesUser?.name : 'NA',
                    // salesManager: popMonthData[i]?.salesManager ? popMonthData[i]?.salesManager?.name : 'NA',
                    // salesDGM: popMonthData[i]?.salesDGM ? popMonthData[i]?.salesDGM?.name : 'NA',
                    // salesAssistantManager: popMonthData[i]?.salesAssistantManager ? popMonthData[i]?.salesAssistantManager?.name : 'NA',

                    // designUser: popMonthData[i]?.designUser ? popMonthData[i]?.designUser?.name : 'NA',
                    // designManager: popMonthData[i]?.designManager ? popMonthData[i]?.designManager?.name : 'NA',
                    // designDGM: popMonthData[i]?.designDGM ? popMonthData[i]?.designDGM?.name : 'NA',
                    // designAssistantManager: popMonthData[i]?.designAssistantManager ? popMonthData[i]?.designAssistantManager?.name : 'NA',
                    currentStage: popMonthData[i].currentStage ? popMonthData[i]?.currentStage : 'NA',
                    department: popMonthData[i]?.departmentId?.name ? popMonthData[i]?.departmentId?.name : 'NA',
                    designStage: popMonthData[i]?.stage ? popMonthData[i]?.stage : "NA",


                    internalDesignSignOffDate: popMonthData[i]?.internalDesignSignOffDate
                        ? moment(popMonthData[i]?.internalDesignSignOffDate).format("DD-MM-YYYY")
                        : "-",
                    designSignOffDate: popMonthData[i]?.customerDesignSignOffDate
                        ? moment(popMonthData[i]?.customerDesignSignOffDate).format("DD-MM-YYYY")
                        : "-",
                    materialDeliveryDate: popMonthData[i]?.materialDispatchedDate
                        ? moment(popMonthData[i]?.materialDispatchedDate).format(
                            "DD-MM-YYYY"
                        )
                        : "-",
                    actualCompletionDate: popMonthData[i]?.executionCompletionDate
                        ? moment(popMonthData[i]?.executionCompletionDate).format(
                            "DD-MM-YYYY"
                        )
                        : "-",
                };
                csvArray.push(obj);
                // obj = {
                //     serialNo: "",
                //     projectCode: "",
                //     clientName: "",
                //     totalValue: "",
                //     expCtrName: "",
                //     salesWonDate: "",
                //     internalDesignSignOffDate: "",
                //     designSignOffDate: "",
                //     materialDeliveryDate: "",
                //     actualCompletionDate: "",
                // };
                // csvArray.push(obj);
            }
            setCsvData(csvArray);
            downloadExcel();
        } catch (error) {
            console.log("error", error);
            props?.setSnackInfo(
                error?.response?.data?.message ?? "Something went wrong",
                "error"
            );
        }
        setLoading(false);
    };

    const downloadExcel = () => {
        setLoading(true);
        try {
            setTimeout(() => {
                csvButtonRef.current.link.click();
            });
        } catch (err) {
            console.error(err.message);
        }
        setLoading(false);
    };
    const expCenterData = {};
    store.forEach((el) => {
        if (!expCenterData[el.experienceCenterName]) {
            expCenterData[el.experienceCenterName] = [];
        }
        expCenterData[el.experienceCenterName].push(el);
    });
    const uniqueexperienceCenterCode = Array.from(new Set(store.map((el) => el.expCenterCode)));
    let uniqueexperienceCenterNames = Array.from(new Set(store.map((el) => el.experienceCenterName)));


    const expCenters = async () => {
        props.setLoading(true);
        try {
            let response = await HttpService.getExpericenCenters();
            const matchedUsers = response.data.filter(user => {
                return userDetails.experienceCenterId.includes(user._id);
            });;
            //   setExpCenter(response.data)
            setExpCenter(matchedUsers)
        } catch (error) {
            console.error("Error fetching experience centers:", error);
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }


    const misReview = async (selectedSearchType, searchInput) => {
        let obj = {
            startDate: storeDateFilter.startDate,
            endDate: storeDateFilter.endDate,
            tokenPercentage: selectedValue !== "" ? selectedValue : "",
            searchType: selectedSearchType ? selectedSearchType : "",
            search: searchInput ? searchInput.toUpperCase() : ""
        }
        props.setLoading(true);
        try {
            let response = await HttpService.overallMISDashBoard(obj);
            setStore(response.data.data);
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }


    const formatNumberToTwoDecimalPlaces = (value) => {
        return parseFloat(value).toFixed(2);
    }

    const storePivotDate = (e) => {
        const { name, value } = e.target
        setPivotDatefilters({ ...storeDateFilter, [name]: value })
    }
    const handlePivotDateFilter = () => {
        misReview(selectedSearchType, searchInput)
    }

    const handleSearchType = (value) => {
        setSelectedSearchType(value)
        setSearchInput('')
    }

    const handleSearch = async (value) => {
        misReview(selectedSearchType, searchInput)
    }
    const handleKeyDown = (event) => {
        if (event.key === 'Enter' && selectedSearchType && searchInput) {
            handleSearch(searchInput.toUpperCase());
        }
    };

    const misDataBasedOnClick = (data, text) => {
        try {
            setShowDetailedModal(true);
            setTitle(text);
            setPopMonthData(data);
            data.forEach(obj => {
                const currentStageConditions = [
                    'Won Deals Pending Designer Assignment',
                    'Designer Assignment Pending',
                    'Design Kick-Off : Internal',
                    'Design Kick-Off : Customer',
                    'Designer Assigned',
                    'Initial Measurement',
                    'Design Discussion',
                    'Finalization of Design',
                    'Final Quote and Design',
                    'Renders',
                    'Finalization of Materials',
                    'Site QC/Project Kick-Off',
                    'Drawing QC'
                ];

                const designStatusConditions = [
                    'Design-Hold',
                    'Possession Delay',
                    'Design-Hold Pending Approval'
                ];

                const lostStageConditions = [
                    'Sales Lost',
                    'Design Lost'
                ];

                if (currentStageConditions.includes(obj.currentStage) ||
                    designStatusConditions.includes(obj.designStatus) ||
                    lostStageConditions.includes(obj.lostStage)) {
                    setTitle("salesWonValue");
                }
            });
        } catch (error) {
            console.log("Error - ", error);
        }
    }

    const dataBasedOnClick = async (e, ele, status) => {
        setStaus(status)
        let expCenterData = selectedExperienceCenter?.map((el) => el._id)
        let users = ''
        if (selectedUsers && selectedUsers.length !== 0) {
            users = selectedUsers?.map((el) => el._id)
        }
        let obj = {
            status: status,
            _id: ele._id,
            selectedExperienceCenter: expCenterData.length !== 0 ? expCenterData : "",
            userExpCenter: userDetails.experienceCenterId,
            tokenPercentage: selectedValue !== "" ? selectedValue : "",
            users: users ? users : "",
            searchType: selectedSearchType ? selectedSearchType : "",
            search: searchInput !== "" ? searchInput.toUpperCase() : ""
        }
        props.setLoading(true);
        if (pivot === "overallReview") {
            obj.role = selectedRole
            if ((status === 'total' && ele._id === 'totals') || ele._id === 'totals') {
                let data = store?.map((el) => el._id)
                data.pop()
                obj._id = data
                obj.startDate = storeDateFilter.startDate
                obj.endDate = storeDateFilter.endDate
            } else {
                let arr = []
                arr.push(ele._id)
                obj._id = arr
                obj.startDate = storeDateFilter.startDate
                obj.endDate = storeDateFilter.endDate
            }
            try {
                let response = await HttpService.getDataBasedClickOveralReview(obj);
                setPopMonthData(response.data)
                setShowDetailedModal(true)
            } catch (error) {
                props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
            }
            props.setLoading(false);
        } else if (pivot === 'designHoldAnalysis') {    //Design-Hold Analysis Dashboard
            obj.role = selectedRole
            if (status === 'total' && ele._id.year !== 'Grand Total') {
                obj.startDate = ''
                obj.endDate = ''
            }
            if (ele?._id?.year === 'Grand Total' && ele?._id?.month === 'Total') {
                obj.startDate = storeDateFilter.startDate
                obj.endDate = storeDateFilter.endDate
            }
            try {
                let response = await HttpService.getDataBasedClickOverallSummary(obj);
                setPopMonthData(response.data)
                setShowDetailedModal(true)
            } catch (error) {
                props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
            }
            props.setLoading(false);

        } else if (pivot === 'mis') {
            if (status === 'total' && ele._id.year !== 'Grand Total') {
                obj.startDate = ''
                obj.endDate = ''
            }
            if (ele?._id?.year === 'Grand Total' && ele?._id?.month === 'Total') {
                obj.startDate = storeDateFilter.startDate
                obj.endDate = storeDateFilter.endDate
            }
            try {
                let response = await HttpService.getDataBasedClickOverallMIS(obj);
                setPopMonthData(response.data)
                setShowDetailedModal(true)
            } catch (error) {
                props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
            }
            props.setLoading(false);
        } else {
            obj.role = selectedRole
            if (status === 'total' && ele._id.year !== 'Grand Total') {
                obj.startDate = ''
                obj.endDate = ''
            }
            if (ele?._id?.year === 'Grand Total' && ele?._id?.month === 'Total') {
                obj.startDate = storeDateFilter.startDate
                obj.endDate = storeDateFilter.endDate
            }
            try {
                let response = await HttpService.getDataBasedClickOverallSummary(obj);
                setPopMonthData(response.data)
                setShowDetailedModal(true)
            } catch (error) {
                props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
            }
            props.setLoading(false);
        }
    }


    const clearDateFilter = () => {
        setSearchInput("")
        setSelectedSearchType("")
        misReview("", "")
    }



    return (
        <div className="App">

            <br />
            <div>
                <Paper className={classes.paper}>
                    <Grid container spacing={2} justifyContent="center" alignItems="center">
                        <Grid item xs={12} sm={2}>
                            <TextField
                                id="startDate"
                                name="startDate"
                                label="From Date"
                                type="date"
                                variant="outlined"
                                value={storeDateFilter.startDate}
                                onChange={storePivotDate}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <TextField
                                id="endDate"
                                name="endDate"
                                label="End Date"
                                type="date"
                                variant="outlined"
                                value={storeDateFilter.endDate}
                                onChange={storePivotDate}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <Button variant="contained" color="primary" onClick={handlePivotDateFilter} style={{ backgroundColor: "#F50057", color: "#fff", padding: "0.4rem 2rem 2rem 2rem" }} className={classes.submitButton}>
                                Submit
                            </Button>
                        </Grid>
                    </Grid>
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: '30px' }}>
                        {/* Search Type Dropdown */}
                        <TextField
                            select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={selectedSearchType}
                            label="Search Type"
                            name="searchType"
                            onChange={(e) => handleSearchType(e.target.value)}
                            variant="outlined"
                            style={{ width: '30%', marginRight: '2%' }}
                            size="small"
                        >
                            {searchTypes && searchTypes?.map((el, index) => (
                                <MenuItem key={index} value={el}>{el}</MenuItem>
                            ))}
                        </TextField>

                        {/* Search Input */}
                        <TextField
                            label="Enter the input"
                            name="searched"
                            size="small"
                            value={searchInput}
                            onChange={(e) => { setSearchInput(e.target.value) }}
                            onKeyDown={handleKeyDown}  // Listening for the "Enter" key press
                            variant="outlined"
                            style={{ width: '80%' }}
                        />

                        {/* Search Button */}
                        <Button
                            disabled={!selectedSearchType || !searchInput}
                            variant="contained"
                            color="primary"
                            size="medium"
                            style={{ alignSelf: "center", marginLeft: 20 }}
                            className={classes.leadSearchButton}
                            onClick={() => handleSearch(searchInput.toUpperCase())}
                        >
                            Search
                        </Button>

                        {/* Clear Filter Button */}
                        <Button
                            variant="contained"
                            color="secondary"
                            size="medium"
                            style={{ marginLeft: 10 }}
                            className={classes.leadClearButton}
                            onClick={clearDateFilter}
                        >
                            Clear Filter
                        </Button>
                    </div>
                </Paper>
            </div>
            <br />
            <div>
                <>
                    <Grid container spacing={2} justifyContent="center" alignItems="center">
                        <Grid item xs={2} >
                            <Button
                                style={{
                                    backgroundColor: '#1C375D',
                                    color: '#FFF2EB',
                                    marginBottom: '10px',

                                }}
                            >
                                MIS -1 Summary-Values
                            </Button>
                        </Grid>
                    </Grid>
                    <div style={{ maxHeight: '600px', overflow: 'auto' }}>
                        <TableContainer component={Paper} classes={{ root: classes.customTableContainer }} style={{ marginTop: '30px' }}>
                            <Table style={{ minWidth: '600px' }}>
                                <TableHead style={{ position: 'sticky', top: 0, zIndex: 9, background: 'white' }}>
                                    <StyledTableRow>
                                        <>
                                            <StyledTableCell className={classes.bordercolors} style={{ position: 'sticky', left: 0, zIndex: 9, textAlign: "center" }} rowSpan={2}>Month And Year</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors} style={{ textAlign: 'center' }}>Designer Not Assigned</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors} style={{ textAlign: 'center' }}>Design Kick Off</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors} style={{ textAlign: 'center' }}>Design</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors} style={{ textAlign: 'center' }}>Design-Hold</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors} style={{ textAlign: 'center' }}>Design Sign-Off</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors} style={{ textAlign: 'center' }}>Design Sign-Off Hold</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors} style={{ textAlign: 'center' }}>Workng Drawing Received</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors} style={{ textAlign: 'center' }}>Production Drawing Received</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors} style={{ textAlign: 'center' }}>Under Machine</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors} style={{ textAlign: 'center' }}>Under Fixing</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors} style={{ textAlign: 'center' }}>Ready For Dispatch</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors} style={{ textAlign: 'center' }}>Under Execution</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors} style={{ textAlign: 'center' }}>Completed</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors} style={{ textAlign: 'center' }}>Sales Lost</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors} style={{ textAlign: 'center' }}>Design Lost</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors} style={{
                                                fontSize: '15px',
                                                textAlign: 'center'
                                            }}>Grand Total</StyledTableCell>
                                        </>
                                    </StyledTableRow>
                                </TableHead>
                                <TableHead style={{ position: 'sticky', top: 0, background: 'white' }}>
                                    {store.map((ele, index) => (
                                        <StyledTableRow key={index}>
                                            {
                                                <>
                                                    {index === store.length - 1 ? (
                                                        <StyledTableCell
                                                            className={classes.bordercolors}
                                                            style={{
                                                                fontSize: index === store.length - 1 ? '15px' : '13px',
                                                                fontWeight: index === store.length - 1 ? 'bolder' : 'normal',
                                                                left: 0,
                                                                position: 'sticky'
                                                            }}
                                                        >
                                                            {ele?._id?.year}
                                                        </StyledTableCell>
                                                    ) : (
                                                        <StyledTableCell
                                                            className={classes.bordercolors}
                                                            style={{
                                                                fontSize: index === store.length - 1 ? '15px' : '13px',
                                                                fontWeight: index === store.length - 1 ? 'bolder' : 'normal',
                                                                left: 0,
                                                                position: 'sticky',
                                                                textAlign: "center"
                                                            }}
                                                        >
                                                            {typeof ele?._id === 'string' && ele?._id.includes("Before")
                                                                ? ele?._id
                                                                : `${months[ele?.month]}-${ele?._id?.year % 100}`}
                                                        </StyledTableCell>
                                                    )}
                                                </>
                                            }

                                            <>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: index !== store.length - 1 ? "#1C375D" : "#355025", textDecoration: "underline", fontWeight: index !== store.length - 1 ? 'normal' : 'bolder', background: "white" }} onClick={() => misDataBasedOnClick(ele.designerNotAssignedData, "designerNotAssigned")}>{(ele.designerNotAssigned)?.toFixed(2)}</StyledTableCell>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: index !== store.length - 1 ? "#1C375D" : "#355025", textDecoration: "underline", fontWeight: index !== store.length - 1 ? 'normal' : 'bolder', background: "white" }} onClick={() => misDataBasedOnClick(ele.designKickOffData, "designKickOff")}>{(ele.designKickOff)?.toFixed(2)}</StyledTableCell>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: index !== store.length - 1 ? "#1C375D" : "#355025", textDecoration: "underline", fontWeight: index !== store.length - 1 ? 'normal' : 'bolder', background: "white" }} onClick={() => misDataBasedOnClick(ele.designData, "design")}>{(ele.design)?.toFixed(2)}</StyledTableCell>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: index !== store.length - 1 ? "#1C375D" : "#355025", textDecoration: "underline", fontWeight: index !== store.length - 1 ? 'normal' : 'bolder', background: "white" }} onClick={() => misDataBasedOnClick(ele.designHoldData, "design-Hold")}>{(ele.designHoldGrand)?.toFixed(2)}</StyledTableCell>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: index !== store.length - 1 ? "#1C375D" : "#355025", textDecoration: "underline", fontWeight: index !== store.length - 1 ? 'normal' : 'bolder', background: "white" }} onClick={() => misDataBasedOnClick(ele.designSignOffData, "designSignOff")}>{(ele.designSignOff)?.toFixed(2)}</StyledTableCell>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: index !== store.length - 1 ? "#1C375D" : "#355025", textDecoration: "underline", fontWeight: index !== store.length - 1 ? 'normal' : 'bolder', background: "white" }} onClick={() => misDataBasedOnClick(ele.designSignOffHoldData, "designSignOffHold")}>{(ele.designSignOffHold)?.toFixed(2)}</StyledTableCell>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: index !== store.length - 1 ? "#1C375D" : "#355025", textDecoration: "underline", fontWeight: index !== store.length - 1 ? 'normal' : 'bolder', background: "white" }} onClick={() => misDataBasedOnClick(ele.workingDrawingReceivedData, "workingDrawingReceived")}>{(ele.workingDrawingReceived)?.toFixed(2)}</StyledTableCell>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: index !== store.length - 1 ? "#1C375D" : "#355025", textDecoration: "underline", fontWeight: index !== store.length - 1 ? 'normal' : 'bolder', background: "white" }} onClick={() => misDataBasedOnClick(ele.productionDrawingReceivedData, "productionDrawingReceived")}>{(ele.productionDrawingReceived)?.toFixed(2)}</StyledTableCell>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: index !== store.length - 1 ? "#1C375D" : "#355025", textDecoration: "underline", fontWeight: index !== store.length - 1 ? 'normal' : 'bolder', background: "white" }} onClick={() => misDataBasedOnClick(ele.underMachineData, "underMachine")}>{(ele.underMachine)?.toFixed(2)}</StyledTableCell>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: index !== store.length - 1 ? "#1C375D" : "#355025", textDecoration: "underline", fontWeight: index !== store.length - 1 ? 'normal' : 'bolder', background: "white" }} onClick={() => misDataBasedOnClick(ele.underFixingData, "underFixing")}>{(ele.underFixing)?.toFixed(2)}</StyledTableCell>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: index !== store.length - 1 ? "#1C375D" : "#355025", textDecoration: "underline", fontWeight: index !== store.length - 1 ? 'normal' : 'bolder', background: "white" }} onClick={() => misDataBasedOnClick(ele.readyForDispatchData, "readyForDispatch")}>{(ele.readyForDispatch)?.toFixed(2)}</StyledTableCell>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: index !== store.length - 1 ? "#1C375D" : "#355025", textDecoration: "underline", fontWeight: index !== store.length - 1 ? 'normal' : 'bolder', background: "white" }} onClick={() => misDataBasedOnClick(ele.underExecutionData, "underExecution")}>{(ele.underExecution)?.toFixed(2)}</StyledTableCell>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: index !== store.length - 1 ? "#1C375D" : "#355025", textDecoration: "underline", fontWeight: index !== store.length - 1 ? 'normal' : 'bolder', background: "white" }} onClick={() => misDataBasedOnClick(ele.completedMWPData, "completedMWP")}>{(ele.completedMWP)?.toFixed(2)}</StyledTableCell>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: index !== store.length - 1 ? "#1C375D" : "#355025", textDecoration: "underline", fontWeight: index !== store.length - 1 ? 'normal' : 'bolder', background: "white" }} onClick={() => misDataBasedOnClick(ele.salesLostData, "salesLost")}>{(ele.salesLost)?.toFixed(2)}</StyledTableCell>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: index !== store.length - 1 ? "#1C375D" : "#355025", textDecoration: "underline", fontWeight: index !== store.length - 1 ? 'normal' : 'bolder', background: "white" }} onClick={() => misDataBasedOnClick(ele.designLostData, "designLost")}>{(ele.designLost)?.toFixed(2)}</StyledTableCell>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: "#004d40", textDecoration: "underline", fontWeight: 'bolder', background: "white" }} onClick={() => misDataBasedOnClick(ele.grandTotalData, "total")}>{(ele.grandTotal)?.toFixed(2)}</StyledTableCell>
                                            </>

                                        </StyledTableRow>
                                    ))}
                                </TableHead>
                            </Table>
                        </TableContainer>
                    </div>

                    <Grid container spacing={2} justifyContent="center" alignItems="center">
                        <Grid item xs={2}>
                            <Button
                                style={{
                                    backgroundColor: '#1C375D',
                                    color: '#FFF2EB',
                                    marginTop: '20px',

                                }}
                            >
                                Total No of Customers
                            </Button>
                        </Grid>
                    </Grid>
                    <div style={{ maxHeight: '600px', overflow: 'auto' }}>
                        <TableContainer component={Paper} classes={{ root: classes.customTableContainer }} style={{ marginTop: '30px' }}>
                            <Table style={{ minWidth: '600px' }}>
                                <TableHead style={{ position: 'sticky', top: 0, zIndex: 9, background: 'white' }}>
                                    <StyledTableRow>
                                        <>
                                            <StyledTableCell className={classes.bordercolors} style={{ position: 'sticky', left: 0, zIndex: 9, textAlign: "center" }} rowSpan={2}>Month And Year</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors} style={{ textAlign: 'center' }}>Designer Not Assigned</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors} style={{ textAlign: 'center' }}>Design Kick Off</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors} style={{ textAlign: 'center' }}>Design</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors} style={{ textAlign: 'center' }}>Design-Hold</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors} style={{ textAlign: 'center' }}>Design Sign-Off</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors} style={{ textAlign: 'center' }}>Design Sign-Off Hold</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors} style={{ textAlign: 'center' }}>Workng Drawing Received</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors} style={{ textAlign: 'center' }}>Production Drawing Received</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors} style={{ textAlign: 'center' }}>Under Machine</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors} style={{ textAlign: 'center' }}>Under Fixing</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors} style={{ textAlign: 'center' }}>Ready For Dispatch</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors} style={{ textAlign: 'center' }}>Under Execution</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors} style={{ textAlign: 'center' }}>Completed</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors} style={{ textAlign: 'center' }}>Sales Lost</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors} style={{ textAlign: 'center' }}>Design Lost</StyledTableCell>
                                            <StyledTableCell className={classes.bordercolors} style={{
                                                fontSize: '15px',
                                                textAlign: 'center'
                                            }}>Grand Total</StyledTableCell>
                                        </>
                                    </StyledTableRow>
                                </TableHead>
                                <TableHead style={{ position: 'sticky', top: 0, background: 'white' }}>
                                    {store.map((ele, index) => (
                                        <StyledTableRow key={index}>
                                            {
                                                <>
                                                    {index === store.length - 1 ? (
                                                        <StyledTableCell
                                                            className={classes.bordercolors}
                                                            style={{
                                                                fontSize: index === store.length - 1 ? '15px' : '13px',
                                                                fontWeight: index === store.length - 1 ? 'bolder' : 'normal',
                                                                left: 0,
                                                                position: 'sticky'
                                                            }}
                                                        >
                                                            {ele?._id?.year}
                                                        </StyledTableCell>
                                                    ) : (
                                                        <StyledTableCell
                                                            className={classes.bordercolors}
                                                            style={{
                                                                fontSize: index === store.length - 1 ? '15px' : '13px',
                                                                fontWeight: index === store.length - 1 ? 'bolder' : 'normal',
                                                                left: 0,
                                                                position: 'sticky',
                                                                textAlign: "center"
                                                            }}
                                                        >
                                                            {typeof ele?._id === 'string' && ele?._id.includes("Before")
                                                                ? ele?._id
                                                                : `${months[ele?.month]}-${ele?._id?.year % 100}`}
                                                        </StyledTableCell>
                                                    )}
                                                </>
                                            }

                                            <>

                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: index !== store.length - 1 ? "#1C375D" : "#355025", textDecoration: "underline", fontWeight: index !== store.length - 1 ? 'normal' : 'bolder', background: "white" }} onClick={() => misDataBasedOnClick(ele.designerNotAssignedData, "designerNotAssigned")}>{ele.designerNotAssignedCount}</StyledTableCell>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: index !== store.length - 1 ? "#1C375D" : "#355025",textDecoration: "underline", fontWeight: index !== store.length - 1 ? 'normal' : 'bolder', background: "white" }} onClick={() => misDataBasedOnClick(ele.designKickOffData, "designKickOff")}>{(ele.designKickOffCount)}</StyledTableCell>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: index !== store.length - 1 ? "#1C375D" : "#355025",textDecoration: "underline", fontWeight: index !== store.length - 1 ? 'normal' : 'bolder', background: "white" }} onClick={() => misDataBasedOnClick(ele.designData, "design")}>{ele.designCount}</StyledTableCell>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: index !== store.length - 1 ? "#1C375D" : "#355025",textDecoration: "underline", fontWeight: index !== store.length - 1 ? 'normal' : 'bolder', background: "white" }} onClick={() => misDataBasedOnClick(ele.designHoldData, "design-Hold")}>{ele.designHoldcount}</StyledTableCell>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: index !== store.length - 1 ? "#1C375D" : "#355025",textDecoration: "underline", fontWeight: index !== store.length - 1 ? 'normal' : 'bolder', background: "white" }} onClick={() => misDataBasedOnClick(ele.designSignOffData, "designSignOff")}>{ele.designSignOffCount}</StyledTableCell>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: index !== store.length - 1 ? "#1C375D" : "#355025",textDecoration: "underline", fontWeight: index !== store.length - 1 ? 'normal' : 'bolder', background: "white" }} onClick={() => misDataBasedOnClick(ele.designSignOffHoldData, "designSignOffHold")}>{ele.designSignOffHoldCount}</StyledTableCell>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: index !== store.length - 1 ? "#1C375D" : "#355025",textDecoration: "underline", fontWeight: index !== store.length - 1 ? 'normal' : 'bolder', background: "white" }} onClick={() => misDataBasedOnClick(ele.workingDrawingReceivedData, "workingDrawingReceived")}>{ele.workingDrawingReceivedCount}</StyledTableCell>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: index !== store.length - 1 ? "#1C375D" : "#355025",textDecoration: "underline", fontWeight: index !== store.length - 1 ? 'normal' : 'bolder', background: "white" }} onClick={() => misDataBasedOnClick(ele.productionDrawingReceivedData, "productionDrawingReceived")}>{ele.productionDrawingReceivedCount}</StyledTableCell>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: index !== store.length - 1 ? "#1C375D" : "#355025",textDecoration: "underline", fontWeight: index !== store.length - 1 ? 'normal' : 'bolder', background: "white" }} onClick={() => misDataBasedOnClick(ele.underMachineData, "underMachine")}>{ele.underMachineCount}</StyledTableCell>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: index !== store.length - 1 ? "#1C375D" : "#355025",textDecoration: "underline", fontWeight: index !== store.length - 1 ? 'normal' : 'bolder', background: "white" }} onClick={() => misDataBasedOnClick(ele.underFixingData, "underFixing")}>{ele.underFixingCount}</StyledTableCell>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: index !== store.length - 1 ? "#1C375D" : "#355025",textDecoration: "underline", fontWeight: index !== store.length - 1 ? 'normal' : 'bolder', background: "white" }} onClick={() => misDataBasedOnClick(ele.readyForDispatchData, "readyForDispatch")}>{ele.readyForDispatchCount}</StyledTableCell>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: index !== store.length - 1 ? "#1C375D" : "#355025",textDecoration: "underline", fontWeight: index !== store.length - 1 ? 'normal' : 'bolder', background: "white" }} onClick={() => misDataBasedOnClick(ele.underExecutionData, "underExecution")}>{ele.underExecutionCount}</StyledTableCell>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: index !== store.length - 1 ? "#1C375D" : "#355025",textDecoration: "underline", fontWeight: index !== store.length - 1 ? 'normal' : 'bolder', background: "white" }} onClick={() => misDataBasedOnClick(ele.completedMWPData, "completedMWP")}>{ele.completedMWPCount}</StyledTableCell>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: index !== store.length - 1 ? "#1C375D" : "#355025",textDecoration: "underline", fontWeight: index !== store.length - 1 ? 'normal' : 'bolder', background: "white" }} onClick={() => misDataBasedOnClick(ele.salesLostData, "salesLost")}>{ele.salesLostCount}</StyledTableCell>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: index !== store.length - 1 ? "#1C375D" : "#355025",textDecoration: "underline", fontWeight: index !== store.length - 1 ? 'normal' : 'bolder', background: "white" }} onClick={() => misDataBasedOnClick(ele.designLostData, "designLost")}>{ele.designLostCount}</StyledTableCell>
                                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", cursor: "pointer", color: "#004d40", textDecoration: "underline", fontWeight: 'bolder', background: "white" }} onClick={() => misDataBasedOnClick(ele.grandTotalData, "total")}>{ele.totalCount}</StyledTableCell>
                                            </>

                                        </StyledTableRow>
                                    ))}
                                </TableHead>
                            </Table>
                        </TableContainer>
                    </div>
                </>
            </div>
            <Modal
                title={pivot}
                centered
                visible={showDetailedModal}
                onCancel={() => setShowDetailedModal(false)}
                width={1000}
                maskClosable={true}
                footer={null}
            >
                <div className={classes.csv}>
                    <CSVLink
                        headers={headers}
                        filename={`${pivot}.csv`}
                        data={csvData}
                        ref={csvButtonRef}
                    />
                    <Button
                        onClick={() => csvDownloadHandler(popMonthData)}
                        style={{ backgroundColor: "#355025",color:"#FFF2EB" }}
                        variant="contained"
                        color="secondary"
                    >
                        Download CSV
                    </Button>
                </div>
                {popMonthData && (
                    <TableContainer component={Paper} className={classes.table}>
                        <Table
                            style={{ width: 450 }}
                            className={classes.table}
                            stickyHeader
                            aria-label="sticky table"
                        >
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell>Sl. No.</StyledTableCell>
                                    <StyledTableCell>Project No.</StyledTableCell>
                                    <StyledTableCell>Lead No.</StyledTableCell>
                                    <StyledTableCell>Client Name</StyledTableCell>
                                    <StyledTableCell>Value (INR)</StyledTableCell>
                                    <StyledTableCell>Exp. Ctr. Name</StyledTableCell>
                                    <StyledTableCell>Sales Won Date</StyledTableCell>
                                    <StyledTableCell>Internal Design Sign-Off Date</StyledTableCell>
                                    <StyledTableCell>Customer Design Sign-Off Approval Date</StyledTableCell>
                                    <StyledTableCell>Material Delivery Date</StyledTableCell>
                                    <StyledTableCell>Actual Completion Date</StyledTableCell>
                                    <StyledTableCell>Current Department</StyledTableCell>
                                    <StyledTableCell>Current Stage</StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                {popMonthData && popMonthData.map((data, i) => {
                                    return (
                                        <>
                                            <StyledTableRow key={i}>
                                                <StyledTableCell>{i + 1}</StyledTableCell>
                                                <StyledTableCell component="th" style={{ textAlign: "center" }}>
                                                    {data?.erpProjectNo ? (
                                                        <Link
                                                            to={`/project-logs/${data?._id}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            style={{ color: "#000", textDecoration: 'underline', textAlign: 'center' }}
                                                        >
                                                            {data?.erpProjectNo}
                                                        </Link>
                                                    ) : (
                                                        'NA'
                                                    )}
                                                </StyledTableCell>
                                                <StyledTableCell component="th" style={{ textAlign: "center" }}>
                                                    {data?.lead_no ? (
                                                        <Link
                                                            to={`/project-logs/${data?._id}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            style={{ color: "#000", textDecoration: 'underline', textAlign: 'center' }}
                                                        >
                                                            {data?.lead_no}
                                                        </Link>
                                                    ) : (
                                                        'NA'
                                                    )}
                                                </StyledTableCell>
                                                {pivot === 'leads' &&
                                                    <>
                                                        <StyledTableCell component="th" style={{ textAlign: "center" }}>
                                                            {data?.createdAt ? moment(data?.createdAt).format("DD-MM-YYYY") : "-"}
                                                        </StyledTableCell>
                                                        <StyledTableCell component="th" style={{ textAlign: "center" }}>
                                                            {data?.sourceOfLead?.name}
                                                        </StyledTableCell>
                                                    </>
                                                }
                                                <StyledTableCell component="th" style={{ textAlign: "center" }}>
                                                    {data?.customerId?.name}
                                                </StyledTableCell>


                                                <StyledTableCell component="th" style={{ textAlign: "center" }}>
                                                    {(["designerNotAssigned", "designKickOff", "design", "design-Hold", "salesLost", "designLost", "salesWonValue"].includes(title)) ?
                                                        (data?.staticSalesWonBudget ? data?.staticSalesWonBudget : "N/A") :
                                                        (data?.staticDesignWonBudget ? data?.staticDesignWonBudget : "N/A")}
                                                </StyledTableCell>

                                                <StyledTableCell component="th">
                                                    {data?.experienceCenterId?.name}
                                                </StyledTableCell>
                                                <StyledTableCell component="th">
                                                    {data?.leadWonDate ? moment(data?.leadWonDate).format("DD-MM-YYYY") : "-"}
                                                </StyledTableCell>
                                                <StyledTableCell component="th">
                                                    {data?.internalDesignSignOffDate ? moment(data?.internalDesignSignOffDate).format("DD-MM-YYYY") : "-"}
                                                </StyledTableCell>
                                                <StyledTableCell component="th">
                                                    {data?.customerDesignSignOffDate ? moment(data?.customerDesignSignOffDate).format("DD-MM-YYYY") : "-"}
                                                </StyledTableCell>
                                                <StyledTableCell component="th">
                                                    {data?.materialDispatchedDate ? moment(data?.materialDispatchedDate).format("DD-MM-YYYY") : "-"}
                                                </StyledTableCell>
                                                <StyledTableCell component="th">
                                                    {data?.executionCompletionDate ? moment(data?.executionCompletionDate).format("DD-MM-YYYY") : "-"}
                                                </StyledTableCell>
                                                <StyledTableCell component="th">
                                                    {data?.departmentId ? data.departmentId?.name : 'NA'}
                                                </StyledTableCell>
                                                <StyledTableCell component="th">
                                                    {data?.currentStage ? data.currentStage : 'NA'}
                                                </StyledTableCell>
                                            </StyledTableRow>

                                        </>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </Modal>
        </div >
    );
}

export default connect(null, { setLoading, setSnackInfo })(MIS1);